/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const COMPLETE_STATUSES = {
  EFFECTIVE: 'EFFECTIVE',
  APPROVED: 'APPROVED',
  FINALIZED: 'FINALIZED',
  ACCEPTED: 'ACCEPTED',
  FILED: 'FILED',
  CUSTOM: 'CUSTOM'
} as const

export type CompleteStatusType = (typeof COMPLETE_STATUSES)[keyof typeof COMPLETE_STATUSES]

// Property types for metadata templates (used in periodic review custom date selection)
export const PROPERTY_TYPE = {
  ARTIFACT: 'ARTIFACT',
  DATETIME: 'DATETIME',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  SELECT_ONE: 'SELECT_ONE',
  SELECT_MULTI: 'SELECT_MULTI',
  SELECT_MULTI_USER: 'SELECT_MULTI_USER',
  SELECT_MULTI_GROUP: 'SELECT_MULTI_GROUP',
  SELECT_ONE_USER: 'SELECT_ONE_USER',
  SELECT_ONE_GROUP: 'SELECT_ONE_GROUP'
} as const

export type PropertyType = keyof typeof PROPERTY_TYPE
